import { render, staticRenderFns } from "./Processos.vue?vue&type=template&id=3b97f831&scoped=true"
import script from "./Processos.vue?vue&type=script&lang=js"
export * from "./Processos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97f831",
  null
  
)

export default component.exports